import React from "react";
import CourseContent from "./CourseContent";
import CourseHeader from "./CourseHeader";

export function CourseOverview({course}) {
  return (
    <>
    {course ? (
      <div className="course-overview-wrapper">
        <CourseHeader course={course} />
        <CourseContent course={course} />
      </div>
    ) : (
      <p>Course Not Found</p>
    )}
    </>
  );
}